/* Hamakija — handwritten notes (.hk-write) write themselves once, when they scroll into view.
   Styles: assets/hk-s-motion.css. Reduced motion / no IntersectionObserver → shown at once. */
(() => {
  if (window.HkWrite) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const show = (el) => el.classList.add('is-written');
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        show(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.5 })
    : null;

  const init = (root = document) => {
    root.querySelectorAll('.hk-write:not(.is-written)').forEach((el) => {
      if (!io || reduce.matches) show(el);
      else io.observe(el);
    });
  };
  window.HkWrite = { init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
